import { render, staticRenderFns } from "./LottoIssueStatList.vue?vue&type=template&id=fe940150&scoped=true"
import script from "./LottoIssueStatList.vue?vue&type=script&lang=js"
export * from "./LottoIssueStatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe940150",
  null
  
)

export default component.exports